import And2 from '../assets/images/Diagrams/AND2.png';
import Nand2 from '../assets/images/Diagrams/NAND2.png';
import Inverter from '../assets/images/Diagrams/Inverter.png';
//TODO: to be fetched from cache
const PREDEFINED_LIBRARIES = ['basic', 'predefined', 'applib'];

//TODO: to be fetched from cache
const VIEW_TYPES = {
    schematic: 1,
    symbol: 2,
    stick: 3 
};

const BASE_URL = process.env.REACT_APP_API_URL;

const SUBSCRIPTION_PLANS = [
  {
    id:"free",
    name: "free",
    price: 0,
    currency:"₹",
    duration: '/12 months for one person',
    label:"Design anything and bring your ideas to life, No cost, just creativity.",
    featuresLabel:"Features you'll love ",
    features: [
      "Easy drag-and-drop editor",
      "2M+ professionally-designed templates",
      "1000+ design types (social posts, docs",
    ]
  },
  {
    id: "plan_RDsZqqdLKPbrui",
    name: "1 Month",
    price: 399,
    currency: "₹",
    duration: "1 Month",
    label:"Design anything and bring your ideas to life, No cost, just creativity.",
    featuresLabel:"Everything in free, plus",
    features: [
      "Easy drag-and-drop editor",
      "2M+ professionally-designed templates",
      "1000+ design types (social posts, docs",
    ]
  },
  {
    id: "plan_RDsZrUrC2XcDF7",
    name: "3 Months",
    price: 499,
    currency: "₹",
    duration: "3 Months",
    label:"Design anything and bring your ideas to life, No cost, just creativity.",
    featuresLabel:"Everything in free, plus",
    features: [
      "Easy drag-and-drop editor",
      "2M+ professionally-designed templates",
      "1000+ design types (social posts, docs,",
    ]
  },
  {
    id: "plan_RDsZs5bSeMXX5k",
    name: "6 Months",
    price: 799,
    currency: "₹",
    duration: "6 Months",
    label:"Design anything and bring your ideas to life, No cost, just creativity.",
    featuresLabel:"Everything in free, plus",
    features: [
      "Easy drag-and-drop editor",
      "2M+ professionally-designed templates",
      "1000+ design types (social posts, docs",
    ]
  },
  {
    id: "plan_RDsZsez42QeipV",
    name: "1 Year",
    price: 999,
    currency: "₹",
    duration: "1 Year",
    label:"Design anything and bring your ideas to life, No cost, just creativity.",
    featuresLabel:"Everything in free, plus",
    features: [
      "Easy drag-and-drop editor",
      "2M+ professionally-designed templates",
      "2M+ professionally-designed templates",
      "2000+ design-types social posts, docs ",
    ]
  }
];

const CIRCUIT_IMAGES = [
  { image: And2, title: "AND Gate" }, 
  { image: Nand2, title: "NAND Gate" }, 
  { image: Inverter, title: "Inverter" }
];

export { PREDEFINED_LIBRARIES, VIEW_TYPES, BASE_URL , SUBSCRIPTION_PLANS , CIRCUIT_IMAGES};
